import { USER_EXISTING_ENDPOINT } from '../config/constants'
import { authorizeHeader } from '../utils/auth-header'


export const patchExistingUserAPICall = async (userId, { user, appMetadata, userMetadata }) => {
  try {
    let payloadToPass = { ...user, ...appMetadata, ...userMetadata }
    const config = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payloadToPass)
    }
    const response = await window.fetch(USER_EXISTING_ENDPOINT + '/' + encodeURIComponent(userId), authorizeHeader(config))
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }
  } catch (e) {
    console.error('ERROR: ', e)
    return e
  }
}

